module.exports = require("./rof.d.ts");